export const environment = {
  production: true,
  buildId: '3558004632022511',
  configFile: 'config.json',
};
